import { HttpParams } from '@angular/common/http';

export function buildParameters(params: Record<string, string | number | boolean | undefined | string[]>): HttpParams {
  const _params = params;
  for (const i in _params) {
    if (typeof _params[i] === 'undefined' || _params[i] === '' || _params[i] === null) {
      delete _params[i];
    }
  }
  return new HttpParams({
    fromObject: _params as Record<string, string | number | boolean | string[]>,
  });
}
